import type {ConnectElementConfig} from '../ConnectElementList';

export const ExportTaxTransactionsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "exportTaxTransactions" */
      '../../../components/Tax/ExportTaxTransactions'
    ),
  releaseState: 'preview',
  sentryTeam: 'tax_connect_embedded_components', // Enter your team's name - this is used for SFX reporting and sentry. See docs on how to set up: https://confluence.corp.stripe.com/display/OBS/Setting+up+Sentry+Reporting#SettingupSentryReporting-SettingupaSentryproject
  teamOwner: 'stripe-tax-expansion',
  description: 'Renders the export tax transactions component for the account.',
  friendlyName: 'Export tax transactions',
  docSitePath: '/connect/supported-embedded-components/export-tax-transactions',
};
